;
var sprite = require("/tmp/build_133e1b25/node_modules/svg-sprite-loader/lib/web/global-sprite");;
var image = "<symbol viewBox=\"0 0 100 100\" id=\"Vitra_Highlights_eb7bc97dec8aa5c92d9156d06175a3fa\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <path d=\"M50,11.43l9.342,28.9h30.457L65.181,58.233l9.438,28.899L50,69.229L25.381,87.133l9.342-28.899L10.203,40.33h30.359\r\n\t\tL50,11.43z M43.383,44.221H22.268l17.029,12.455l-6.617,20.337c6.13-4.379,11.968-8.66,17.319-12.552l17.32,12.552l-6.714-20.239\r\n\t\tl17.223-12.552H56.521l-6.617-20.239L43.383,44.221z\"/> </g> </symbol>";
module.exports = sprite.add(image, "Vitra_Highlights_eb7bc97dec8aa5c92d9156d06175a3fa");


//////////////////
// WEBPACK FOOTER
// ./images/icons/Vitra_Highlights.svg
// module id = 1407
// module chunks = 0